import React, { FunctionComponent, useEffect, useState, useLayoutEffect } from 'react';
import { IConsumptionCardData } from '../context';
import { initCardObserverAnimation } from './util';
import { colorArr } from './const';
import { Tooltip } from 'antd';
import cx from 'classnames';
import styles from './energyConsumption.module.less';

interface IProps {
  dataSource: IConsumptionCardData[]
}

const imgArr = ['測試標準路徑', '實測發票', '旅程表數據']

const EnergyConsumption: FunctionComponent<IProps> = ({ dataSource }) => {
  const [activeName, setActiveName] = useState('');

  useLayoutEffect(() => {
    const eles = document.querySelectorAll('.energy-card');

    if (eles.length) {
      initCardObserverAnimation(eles);
    }

  }, [dataSource])

  return (
    <div className={styles["energy-card"]}>
      {
        dataSource.map((item, inx) => (
          <div className={cx(styles['card-item'], 'energy-card')} key={inx}>
            <div className={cx(styles['card-wrapper'], "card-wrapper")}>
              <div className={styles['card-title']}>
                <i style={{ backgroundColor: colorArr[inx] }}></i>
                <h4>{item.title}</h4>
              </div>
              <div className={styles['card-info']}>
                <img className={styles['thumb']} src={item.thumb} alt="" />
                <div className={styles['detail-list']}>
                  <p>實測環境:<span>{item.environment}</span></p>
                  <p>胎壓:<span>{item.tirePressure}</span></p>
                  <p>能源局數據:<span>{item.bureauEnergyData}</span></p>
                  <p>平均燃油費預計:<span>{item.avgYearEnergyConsumption}</span></p>
                </div>
              </div>
              <div className={styles['card-detail']}>
                {
                  item.showImage.map((i, index) => {
                    const Context = () => (
                      <div className={styles['image-lazy']}>
                        <img src={i.value} alt="" />
                      </div>
                    )
                    return (
                      <Tooltip title={Context}>
                        <div 
                          className={styles['preview']}
                          onMouseEnter={() => setActiveName(item.title + i.key)}
                          onMouseLeave={() => setActiveName('')}
                          key={index}
                        >
                          {imgArr?.[index]}
                          <i></i>
                        </div>
                      </Tooltip>
                    )
                  })
                }
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default EnergyConsumption;